/* Santas Vault live design preview.
   Renders the chosen design with the customer's own wording, client side, as they type.
   Geometry mirrors bold.py so what is previewed is what gets printed. */
(function(){
  var RED="#E03C31",RED_D="#B32B22",GRN="#1E9E5A",GRN_D="#14713F",
      GOLD="#F5B921",GOLD_D="#C98F0C",CREAM="#FFF6E3",INK="#16241E",
      SKY="#4FB3D9",BERRY="#C2185B",BROWN="#A9703C",BROWN_D="#7A4A21";
  var W=1000,H=1000;

  function esc(s){return String(s||"").replace(/[<>&]/g,function(c){return {"<":"&lt;",">":"&gt;","&":"&amp;"}[c];});}
  function starN(cx,cy,ro,ri,n,rot,fill){
    var p=[],i,a,r; n=n||8; rot=(rot===undefined?-90:rot);
    for(i=0;i<n*2;i++){a=(rot+i*180/n)*Math.PI/180;r=(i%2===0)?ro:ri;
      p.push((cx+r*Math.cos(a)).toFixed(1)+","+(cy+r*Math.sin(a)).toFixed(1));}
    return '<path d="M'+p.join("L")+'Z" fill="'+fill+'"/>';
  }
  function star5(cx,cy,r,fill){
    var p=[],i,a,rr;
    for(i=0;i<10;i++){a=(-90+i*36)*Math.PI/180;rr=(i%2===0)?r:r*0.42;
      p.push((cx+rr*Math.cos(a)).toFixed(1)+","+(cy+rr*Math.sin(a)).toFixed(1));}
    return '<path d="M'+p.join("L")+'Z" fill="'+fill+'"/>';
  }
  function hat(cx,cy,s){
    return '<path d="M'+(cx-s*.62)+','+(cy+s*.30)+' C'+(cx-s*.52)+','+(cy-s*.58)+' '+(cx+s*.30)+','+(cy-s*.78)+' '+(cx+s*.62)+','+(cy-s*.18)+' L'+(cx+s*.30)+','+(cy+s*.30)+' Z" fill="'+RED+'"/>'
      +'<rect x="'+(cx-s*.74)+'" y="'+(cy+s*.24)+'" width="'+(s*1.20)+'" height="'+(s*.34)+'" rx="'+(s*.17)+'" fill="'+CREAM+'"/>'
      +'<circle cx="'+(cx+s*.66)+'" cy="'+(cy-s*.22)+'" r="'+(s*.24)+'" fill="'+CREAM+'"/>';
  }
  function bauble(cx,cy,r,fill){
    return '<circle cx="'+cx+'" cy="'+cy+'" r="'+r+'" fill="'+fill+'"/>'
      +'<circle cx="'+(cx-r*.30)+'" cy="'+(cy-r*.32)+'" r="'+(r*.26)+'" fill="#fff" opacity=".45"/>'
      +'<rect x="'+(cx-r*.26)+'" y="'+(cy-r-r*.34)+'" width="'+(r*.52)+'" height="'+(r*.36)+'" rx="'+(r*.10)+'" fill="'+GOLD+'"/>';
  }
  function tree(cx,base,h,w){
    var o="",k,t,top,bot,ww,i,seed=3,bx,by,cols=[RED,GOLD,SKY,CREAM];
    for(k=0;k<3;k++){t=k/3;top=base-h+(h*.72)*t;bot=top+h*.42;ww=w*(.46+.54*t);
      o+='<path d="M'+cx+','+top+' L'+(cx+ww/2)+','+bot+' L'+(cx-ww/2)+','+bot+' Z" fill="'+GRN+'"/>';}
    o+='<rect x="'+(cx-w*.07)+'" y="'+(base-h*.03)+'" width="'+(w*.14)+'" height="'+(h*.13)+'" rx="'+(w*.02)+'" fill="'+BROWN_D+'"/>';
    for(i=0;i<11;i++){seed=(seed*9301+49297)%233280;bx=cx+((seed/233280)-0.5)*w*.68;
      seed=(seed*9301+49297)%233280;by=base-(h*.14+(seed/233280)*h*.58);
      o+='<circle cx="'+bx.toFixed(0)+'" cy="'+by.toFixed(0)+'" r="'+(w*.055)+'" fill="'+cols[i%4]+'"/>';}
    o+=star5(cx,base-h-w*.02,w*.20,GOLD);
    return o;
  }
  function deer(cx,cy,s){
    var o="",sd,i,arms=[[.40,-.34],[.46,-.62],[.34,-.06]];
    for(sd=-1;sd<=1;sd+=2){
      o+='<path d="M'+(cx+sd*s*.30)+','+(cy-s*.30)+' C'+(cx+sd*s*.52)+','+(cy-s*.78)+' '+(cx+sd*s*.86)+','+(cy-s*.86)+' '+(cx+sd*s*.96)+','+(cy-s*1.16)+'" fill="none" stroke="'+BROWN_D+'" stroke-width="'+(s*.14)+'" stroke-linecap="round"/>';
      for(i=0;i<arms.length;i++)
        o+='<path d="M'+(cx+sd*s*arms[i][0])+','+(cy+s*arms[i][1])+' l'+(sd*s*.34)+','+(-s*.22)+'" fill="none" stroke="'+BROWN_D+'" stroke-width="'+(s*.11)+'" stroke-linecap="round"/>';
    }
    o+='<ellipse cx="'+cx+'" cy="'+(cy+s*.10)+'" rx="'+(s*.56)+'" ry="'+(s*.60)+'" fill="'+BROWN+'"/>'
      +'<ellipse cx="'+cx+'" cy="'+(cy+s*.34)+'" rx="'+(s*.30)+'" ry="'+(s*.24)+'" fill="#C79262"/>';
    for(sd=-1;sd<=1;sd+=2) o+='<circle cx="'+(cx+sd*s*.22)+'" cy="'+(cy-s*.02)+'" r="'+(s*.075)+'" fill="'+INK+'"/>';
    o+='<circle cx="'+cx+'" cy="'+(cy+s*.34)+'" r="'+(s*.15)+'" fill="'+RED+'"/>';
    return o;
  }
  function candy(x,y,h,w){
    var o='<rect x="'+(x-w/2)+'" y="'+y+'" width="'+w+'" height="'+h+'" rx="'+(w/2)+'" fill="'+CREAM+'"/>',
        n=Math.floor(h/(w*0.75)),i,yy;
    for(i=0;i<n;i++){yy=y+i*(h/n);
      o+='<rect x="'+(x-w/2)+'" y="'+yy+'" width="'+w+'" height="'+(h/n*0.5)+'" fill="'+RED+'"/>';}
    return o;
  }
  function sunburst(cx,cy,R,fill,n,op){
    var o="",i,a0,a1; n=n||20;
    for(i=0;i<n;i++){a0=i*2*Math.PI/n;a1=a0+(2*Math.PI/n)*0.52;
      o+='<path d="M'+cx+','+cy+' L'+(cx+R*Math.cos(a0)).toFixed(0)+','+(cy+R*Math.sin(a0)).toFixed(0)
        +' L'+(cx+R*Math.cos(a1)).toFixed(0)+','+(cy+R*Math.sin(a1)).toFixed(0)+' Z" fill="'+fill+'" opacity="'+op+'"/>';}
    return o;
  }
  function fairisle(x,y,w,h){
    var o='<rect x="'+x+'" y="'+y+'" width="'+w+'" height="'+h+'" fill="'+GRN_D+'"/>',
        step=w/9,i,cx;
    for(i=0;i<9;i++){cx=x+step*(i+.5);
      o+='<path d="M'+(cx-step*.30)+','+(y+h*.70)+' L'+cx+','+(y+h*.22)+' L'+(cx+step*.30)+','+(y+h*.70)+' Z" fill="'+CREAM+'"/>';
      o+='<circle cx="'+(cx-step*.5)+'" cy="'+(y+h*.45)+'" r="'+(step*.09)+'" fill="'+GOLD+'"/>';}
    return o;
  }
  function plaid(x,y,w,h){
    var o='<rect x="'+x+'" y="'+y+'" width="'+w+'" height="'+h+'" fill="'+RED+'"/>',s=w/7,t=h/7,i;
    for(i=0;i<8;i++){
      o+='<rect x="'+(x+i*s)+'" y="'+y+'" width="'+(s*.34)+'" height="'+h+'" fill="'+GRN_D+'" opacity=".85"/>';
      o+='<rect x="'+(x+i*s+s*.42)+'" y="'+y+'" width="'+(s*.07)+'" height="'+h+'" fill="'+CREAM+'" opacity=".9"/>';}
    for(i=0;i<8;i++){
      o+='<rect x="'+x+'" y="'+(y+i*t)+'" width="'+w+'" height="'+(t*.34)+'" fill="'+GRN_D+'" opacity=".55"/>';
      o+='<rect x="'+x+'" y="'+(y+i*t+t*.42)+'" width="'+w+'" height="'+(t*.07)+'" fill="'+CREAM+'" opacity=".75"/>';}
    return o;
  }
  function txt(s,size,x,y,fill,fam,weight,track,stroke,sw){
    return '<text x="'+x+'" y="'+y+'" font-family="'+(fam||"Fraunces, Georgia, serif")+'" font-size="'+size+'"'
      +' font-weight="'+(weight||"600")+'" fill="'+fill+'" text-anchor="middle"'
      +(track?' letter-spacing="'+track+'"':'')
      +(stroke?' stroke="'+stroke+'" stroke-width="'+sw+'" paint-order="stroke"':'')
      +'>'+esc(s)+'</text>';
  }
  function fit(s,base,maxChars){
    var n=Math.max(String(s||"").length,1);
    return n<=maxChars?base:Math.max(base*maxChars/n, base*0.42);
  }

  var D={};
  D["Ho Ho Ho"]=function(n){var s=fit(n,230,8);
    return '<ellipse cx="500" cy="500" rx="470" ry="440" fill="'+CREAM+'"/>'
    +txt("HO HO HO",160,500,330,RED,"Karla, sans-serif","800",8)
    +hat(200,170,160)+star5(810,160,85,GOLD)
    +txt(n,s,500,620,GRN_D,null,"700",0,CREAM,18)
    +'<rect x="200" y="672" width="600" height="16" rx="8" fill="'+GOLD+'"/>'
    +txt("MERRY CHRISTMAS",66,500,800,RED,"Karla, sans-serif","700",11);};
  D["Bright Tree"]=function(n){var s=fit(n,215,8);
    return tree(500,600,460,480)
    +bauble(80,300,55,RED)+bauble(940,260,50,SKY)+bauble(140,500,45,GOLD)+bauble(880,520,48,BERRY)
    +txt(n,s,500,800,RED,null,"700",0,CREAM,18)
    +txt("MERRY CHRISTMAS",58,500,900,GRN,"Karla, sans-serif","700",10);};
  D["Reindeer"]=function(n){var s=fit(n,230,8);
    return deer(500,330,340)
    +txt(n,s,500,740,CREAM,null,"700",0,INK,20)
    +txt("MERRY CHRISTMAS",60,500,850,GOLD,"Karla, sans-serif","700",10);};
  D["Candy Cane"]=function(n){var s=fit(n,175,7);
    return candy(130,120,760,115)+candy(870,120,760,115)
    +'<rect x="240" y="220" width="520" height="560" rx="60" fill="'+CREAM+'"/>'
    +'<rect x="265" y="245" width="470" height="510" rx="50" fill="none" stroke="'+RED+'" stroke-width="20"/>'
    +star5(500,335,85,GOLD)
    +txt(n,s,500,560,GRN_D,null,"700")
    +txt("MERRY CHRISTMAS",46,500,655,RED,"Karla, sans-serif","700",7);};
  D["Bauble Line"]=function(n){var s=fit(n,240,8),o="",cols=[RED,GOLD,SKY,BERRY,GRN],i,x,drop;
    o+='<path d="M20,115 Q500,200 980,115" fill="none" stroke="'+GRN_D+'" stroke-width="22"/>';
    for(i=0;i<5;i++){x=500+(i-2)*170;drop=90+50*Math.abs(i-2);
      o+='<line x1="'+x+'" y1="140" x2="'+x+'" y2="'+(140+drop)+'" stroke="'+GOLD_D+'" stroke-width="10"/>'
        +bauble(x,140+drop+95,95,cols[i]);}
    return o+txt(n,s,500,720,CREAM,null,"700",0,INK,20)
    +txt("MERRY CHRISTMAS",60,500,840,GOLD,"Karla, sans-serif","700",10);};
  D["Santa Badge"]=function(n){var s=fit(n,185,8),o="",i,a;
    o+='<circle cx="500" cy="480" r="420" fill="'+RED+'"/>'
     +'<circle cx="500" cy="480" r="370" fill="none" stroke="'+CREAM+'" stroke-width="22"/>';
    for(i=0;i<12;i++){a=(i*30-90)*Math.PI/180;
      o+=star5(500+407*Math.cos(a),480+407*Math.sin(a),30,GOLD);}
    return o+hat(500,312,150)
    +txt(n,s,500,572,CREAM,null,"700")
    +'<rect x="307" y="618" width="386" height="12" fill="'+GOLD+'"/>'
    +txt("CHRISTMAS 2026",55,500,720,GOLD,"Karla, sans-serif","700",9);};
  D["Aussie Christmas"]=function(n){var s=fit(n,215,8);
    return sunburst(500,330,500,"#FFD24A",20,.30)
    +'<circle cx="500" cy="330" r="345" fill="'+SKY+'"/>'
    +'<circle cx="690" cy="225" r="100" fill="'+GOLD+'"/>'
    +hat(350,275,155)
    +'<path d="M155,415 q115,-85 230,0 q115,-85 230,0 q115,-85 230,0" fill="none" stroke="'+CREAM+'" stroke-width="36" stroke-linecap="round"/>'
    +'<path d="M155,455 q115,-85 230,0 q115,-85 230,0 q115,-85 230,0" fill="none" stroke="'+CREAM+'" stroke-width="26" stroke-linecap="round" opacity=".7"/>'
    +txt(n,s,500,720,RED,null,"700",0,CREAM,18)
    +txt("AN AUSSIE CHRISTMAS",55,500,840,GRN_D,"Karla, sans-serif","700",9);};

  /* family role designs: role is the hero, surname the anchor */
  D["Santa Hat Badge"]=function(role,sn){var s=fit(role,230,9);
    return sunburst(500,440,520,"#FFD24A",20,.34)
    +txt(sn?("THE "+sn.toUpperCase()+" FAMILY"):"CHRISTMAS 2026",62,500,175,GOLD,"Karla, sans-serif","700",10)
    +hat(500,300,155)
    +txt(role,s,500,625,CREAM,null,"700",0,INK,20)
    +'<rect x="180" y="665" width="640" height="16" rx="8" fill="'+GOLD+'"/>'
    +txt("MERRY CHRISTMAS",62,500,775,GOLD,"Karla, sans-serif","700",11);};
  D["Retro Arch"]=function(role,sn){var s=fit(role,165,9),o="",i,ch,a,tt="MERRY CHRISTMAS",R=243;
    o+=sunburst(500,460,560,"#FFD24A",22,.55)+'<circle cx="500" cy="460" r="315" fill="'+CREAM+'"/>';
    for(i=0;i<tt.length;i++){ch=tt[i];if(ch===" ")continue;
      a=(-66+i*(132/(tt.length-1))-90)*Math.PI/180;
      o+='<g transform="translate('+(500+R*Math.cos(a)).toFixed(1)+','+(460+R*Math.sin(a)).toFixed(1)+') rotate('+(a*180/Math.PI+90).toFixed(1)+')">'
        +'<text font-family="Karla, sans-serif" font-size="78" font-weight="700" fill="'+RED+'" text-anchor="middle">'+esc(ch)+'</text></g>';}
    return o+txt(role,s,500,500,GRN_D,null,"700")
    +'<rect x="360" y="535" width="280" height="12" fill="'+GOLD_D+'"/>'
    +txt(sn?sn.toUpperCase():"2026",55,500,610,RED,"Karla, sans-serif","700",9);};
  D["Ugly Sweater"]=function(role,sn){var s=fit(role,215,9);
    return '<rect x="0" y="60" width="1000" height="880" rx="50" fill="'+RED_D+'"/>'
    +fairisle(0,140,1000,150)+fairisle(0,710,1000,150)
    +txt(role,s,500,520,CREAM,null,"700",0,INK,18)
    +txt(sn?(sn.toUpperCase()+" FAMILY"):"CHRISTMAS 2026",58,500,625,GOLD,"Karla, sans-serif","700",10);};
  D["Christmas Plaid"]=function(role,sn){var s=fit(role,170,9);
    return plaid(0,60,1000,880)
    +'<rect x="70" y="360" width="860" height="300" rx="45" fill="'+CREAM+'"/>'
    +txt(role,s,500,525,RED_D,null,"700")
    +txt(sn?sn.toUpperCase():"MERRY CHRISTMAS",50,500,605,GRN_D,"Karla, sans-serif","700",9);};
  D["Aussie Summer"]=function(role,sn){var s=fit(role,195,9);
    return sunburst(500,330,500,"#FFD24A",20,.30)
    +'<circle cx="500" cy="330" r="345" fill="'+SKY+'"/>'
    +'<circle cx="690" cy="225" r="100" fill="'+GOLD+'"/>'+hat(350,275,155)
    +'<path d="M155,415 q115,-85 230,0 q115,-85 230,0 q115,-85 230,0" fill="none" stroke="'+CREAM+'" stroke-width="36" stroke-linecap="round"/>'
    +txt(role,s,500,685,RED,null,"700",0,CREAM,18)
    +txt(sn?(sn.toUpperCase()+" FAMILY"):"AN AUSSIE CHRISTMAS",55,500,790,GRN_D,"Karla, sans-serif","700",9);};

  var FAMILY={"Santa Hat Badge":1,"Retro Arch":1,"Ugly Sweater":1,"Christmas Plaid":1,"Aussie Summer":1};

  window.SVPreview=function(key,a,b){
    var fn=D[key]; if(!fn) return "";
    var out = FAMILY[key] ? fn(a||"Mum", b||"") : fn(a||"Your name");
    return '<svg viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">'+out+'</svg>';
  };
  function render(){
    var box=document.getElementById("sv-preview-svg"); if(!box) return;
    var sel=document.querySelector('.sv-dgrid input:checked');
    var key=sel?sel.value:"Santa Hat Badge";
    var fn=D[key]; if(!fn){box.innerHTML="";return;}
    var out;
    if(FAMILY[key]){
      var role=(document.getElementById("sv-role")||{}).value||"Mum";
      var sn=((document.getElementById("sv-surname")||{}).value||"").trim();
      out=fn(role,sn);
    } else {
      var nm=((document.getElementById("sv-perso-input")||{}).value||"").trim()||"Your name";
      out=fn(nm);
    }
    box.innerHTML='<svg viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">'+out+'</svg>';
  }
  function bind(){
    ["sv-perso-input","sv-role","sv-surname"].forEach(function(id){
      var e=document.getElementById(id); if(e){e.addEventListener("input",render);e.addEventListener("change",render);}
    });
    var g=document.querySelector(".sv-dgrid"); if(g) g.addEventListener("change",render);
    render();
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",bind); else bind();
  document.addEventListener("shopify:section:load",bind);
})();
